export const proveedorRouteMap = {
  gestion: {
    path: `/proveedor/gestion`,
    name: 'Proveedores',
  },
  nuevo: {
    path: `/proveedor/nuevo`,
    name: 'Nuevo Proveedor',
  },
  modificar: {
    path: `/proveedor/modificar`,
    name: 'Modificar Proveedor',
  },
}
